<template>
  <el-dialog
    title="登记劳保用品"
    :visible.sync="addLaborSupliesVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form
      ref="addLaborSupliesRef"
      label-width="150px"
      :model="addLaborSupliesForm"
      class="clear-placeholer"
    >
      <el-form-item
        label="劳保用品名称"
        prop="name"
        :rules="[
          {
            required: true,
            message: '请输入劳保用品名称',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          :disabled="pageConfigType === 'read'"
          v-model="addLaborSupliesForm.name"
          maxlength="50"
          placeholder="请输入劳保用品名称"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="数量"
        prop="quantity"
        :rules="[
          {
            required: true,
            message: '请输入数量',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          :disabled="pageConfigType === 'read'"
          v-model="addLaborSupliesForm.quantity"
          maxlength="50"
          placeholder="请输入数量"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        label="购买时间"
        prop="purchasedTime"
        :rules="[
          {
            required: true,
            message: '请选择购买时间',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          size="small"
          v-model="addLaborSupliesForm.purchasedTime"
          type="date"
          placeholder="请选择时间"
          value-format="yyyy-MM-dd"
          clearable
          :disabled="pageConfigType === 'read'"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="two-row" label="检查周期" :rules="[{ required: true, trigger: 'blur' }]">
        <el-input-number
          v-model="addLaborSupliesForm.checkFrequency"
          :min="1"
          :disabled="pageConfigType === 'read'"
        ></el-input-number>
        <el-select
          v-model="addLaborSupliesForm.checkFrequencyType"
          size="small"
          placeholder="请选择"
          clearable
          :disabled="pageConfigType === 'read'"
        >
          <el-option
            v-for="item in checkFrequencyList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="addLaborSupliesForm.remark"
          maxlength="50"
          type="textarea"
          rows="3"
          placeholder="请输入备注"
          :disabled="pageConfigType === 'read'"
        />
      </el-form-item>
      <el-form-item
        label="合格证书"
        prop="certificatesStr"
        ref="certificatesStr"
        :rules="[
          {
            required: true,
            message: '请选择合格证书',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <form-upload
          v-model="addLaborSupliesForm.certificatesStr"
          :limit="9999"
          :disabled="pageConfigType === 'read'"
          :accept="['jpg', 'png', 'doc', 'docx', 'pdf', 'xlsx', 'xls']"
          @change="fileIdChange('certificatesStr')"
          @exposeFileList="exposeFileList"
          class="w-440px"
        ></form-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import utils from '@/components/safety/enumField/utils'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import {
  WorkPermitAddtionalGuidanceConfigurationDirectoriesApi,
  ContractorApi,
} from '@wiz-api/contractor-management'
import dayjs from 'dayjs'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'

const workPermitAddtionalGuidanceConfigurationDirectorysApi = new WorkPermitAddtionalGuidanceConfigurationDirectoriesApi()
const contractorApi = new ContractorApi()

export default {
  components: {
    FormUpload,
  },
  model: {
    prop: 'addLaborSupliesVisible',
    event: 'addLaborSupliesChange',
  },
  props: {
    addLaborSupliesVisible: {
      type: Boolean,
      default: false,
    },
    checkFrequencyList: {
      type: Array,
      default: () => {
        return []
      },
    },
    contractorId: {
      type: String,
      default: '',
    },
    saveLabrRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
    pageConfigType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      fileList: [],
      loading: false,
      addLaborSupliesForm: {
        checkFrequency: 1,
        checkFrequencyType: 1,
      },
      taskFrequencyType: [],
      workPermitCategoryList: [],
      laborSupliesType: [],
    }
  },
  watch: {
    saveLabrRow: {
      handler(val) {
        if (val.id) {
          this.addLaborSupliesForm = val
          this.addLaborSupliesForm.certificatesStr = val.certificates.join(',')
          if (this.pageConfigType === 'read') {
            clearPlaceholder('.clear-placeholer')
          }
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await utils.getDataCategory(
      ['ContractorManagement.DataCategory.WorkPermitCategory'],
      ['workPermitCategoryList'],
      this
    )
  },
  methods: {
    exposeFileList(fileList) {
      this.fileList = fileList
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.addLaborSupliesForm = {
        checkFrequency: 1,
        checkFrequencyType: 1,
      }
      this.$refs.addLaborSupliesRef.resetFields()
      this.$emit('addLaborSupliesChange', false)
    },
    save() {
      this.$refs.addLaborSupliesRef.validate(async (valid) => {
        if (valid) {
          this.addLaborSupliesForm.certificates = this.addLaborSupliesForm.certificatesStr.split(
            ','
          )
          if (this.addLaborSupliesForm.purchasedTime) {
            this.addLaborSupliesForm.purchasedTime = dayjs(
              this.addLaborSupliesForm.purchasedTime
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          this.addLaborSupliesForm.certificateNames = this.fileList.map((item) => {
            return item.name
          })
          this.loading = true
          if (!this.saveLabrRow.id) {
            const [err, res] = await contractorApi.createLaborInsuranceSupplies(this.contractorId, {
              body: this.addLaborSupliesForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.cancel()
            }
          } else {
            const [err, res] = await contractorApi.updateLaborInsuranceSupplies(
              this.contractorId,
              this.saveLabrRow.id,
              {
                body: this.addLaborSupliesForm,
              }
            )
            if (!err) {
              this.$message.success('修改成功')
              this.cancel()
            }
          }

          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
.two-row {
  ::v-deep .el-form-item__content {
    margin-right: 0px;
    width: 440px;
    display: flex;
    .el-input-number {
      width: 150px;
      margin-right: 10px;
    }
    .el-select {
      flex: 1;
      .el-input {
        width: 100%;
      }
    }
  }
}
</style>
